module.exports = __webpack_public_path__ + "img/Logos-EJ-michelin.c0105272.jpg";